import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, usePrefs } from 'wsm-common-data';
import MenuLink from './MenuLink';
import NavIcon from './NavIcon';

const DropdownItem = ({ url, target, labelAlias, enabled }) => {
	const labels = useLabels();
	const { childListLinkClasses } = usePrefs();

	if (!enabled) return <></>;

	const classes = `child ${childListLinkClasses}`;
	const additionalAttrs = { 'data-navigation-id': 'default' };

	return (
		<MenuLink
			childListLinkClasses={classes}
			url={url}
			target={target}
			additionalAttrs={additionalAttrs}
		>
			<NavIcon labels={labels} labelAlias={labelAlias} />
		</MenuLink>
	);
};
DropdownItem.propTypes = {
	url: PropTypes.string.isRequired,
	target: PropTypes.string.isRequired,
	enabled: PropTypes.bool.isRequired,
	labelAlias: PropTypes.string.isRequired
};

export default DropdownItem;
